export default function IncludedServices() {
  const services = [
    {
      icon: 'ri-presentation-line',
      title: 'Bilimsel Oturumlar',
      description: 'Alanında uzman hocalarımızdan dolu dolu sürecek bilimsel oturumlar.',
      color: 'from-[#0D1B3E] to-[#1a2f5a]'
    },
    {
      icon: 'ri-award-line',
      title: 'Kongre Katılım Sertifikası',
      description: 'Kongre katılım sertifikası ve resmî belgeler.',
      color: 'from-[#1A9B8C] to-[#15806f]'
    },
    {
      icon: 'ri-gift-line',
      title: 'Sürpriz Çekilişler',
      description: 'Kongre boyunca düzenlenecek sürpriz çekilişler ve hediyeler.',
      color: 'from-[#C9A84C] to-[#a88a3d]'
    },
    {
      icon: 'ri-store-3-line',
      title: 'Fuaye Alanı',
      description: 'Sponsorlarımızın katılımı ile hazırlanan zengin fuaye alanı.',
      color: 'from-[#0D1B3E] to-[#1a2f5a]'
    },
  ];

  return (
    <div className="bg-gradient-to-b from-white to-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-[#1A9B8C] to-[#15806f] rounded-full mb-4 animate-float">
            <i className="ri-checkbox-circle-line text-white text-2xl"></i>
          </div>
          <h2 className="text-4xl font-bold text-[#0D1B3E] mb-4">Kongre İçeriği</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Kongre kayıt ücretinize dahil olan tüm hizmetler ve avantajlar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:-translate-y-1 group animate-slide-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className={`w-16 h-16 bg-gradient-to-r ${service.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#0D1B3E] mb-2">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#0D1B3E] to-[#1a2f5a] rounded-2xl p-8 text-white text-center shadow-xl animate-fade-in">
          <div className="flex items-center justify-center gap-3 mb-4">
            <i className="ri-shield-check-line text-4xl text-[#C9A84C]"></i>
            <h3 className="text-2xl font-bold">Güvenli Ödeme</h3>
          </div>
          <p className="text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Tüm ödemeler güvenli ödeme sistemi ile <strong>İdenta Event Organizasyon</strong> hesabına yapılmaktadır.
            Farklı hesaplara yapılan ödemeler kabul edilmeyecektir. Kayıt işleminiz tamamlandıktan sonra
            ödeme talimatları e-posta ile tarafınıza iletilecektir.
          </p>
        </div>
      </div>
    </div>
  );
}